import Markdown from "markdown-to-jsx";
import { RefObject } from "react";
import { cmsUrl } from "../http/cmsApi";
import SVGOpen from "../icons/Open.svg?react";
import { TextSections } from "../types/types";
import styles from "./TabPanel.module.css";
import Icon from "./ui/Icon";
import Link from "./ui/Link";

interface Props {
  content: TextSections;
  tabPanelRef: RefObject<HTMLDivElement>;
}

const TabPanel = ({ content, tabPanelRef }: Props) => {
  return (
    <div ref={tabPanelRef}>
      <h3 className={styles.title}>
        {content.section} {content.title}
      </h3>
      <Markdown>{content.text}</Markdown>
      {content.pdf && (
        <div className={styles["pdf-container"]}>
          <Link
            newTab={true}
            url={`${cmsUrl}${location.pathname}/${content.pdf}`}
          >
            <Icon glyph={SVGOpen} /> Als PDF öffnen
          </Link>
        </div>
      )}
    </div>
  );
};

export default TabPanel;
